import axios from "../../axios";
import { useMutation, useQuery, useQueryClient } from "react-query"
import { route } from './routes';
import { message } from "antd";



// add state
export function useAddState(){
  const queryClient = useQueryClient();
  return useMutation(async(payload) => {
    const { data } = await axios.post(route.ADD_STATE ,payload);
    return data;
  }, {
    onSuccess:() => {
      message.success('State added successfully');
      queryClient.invalidateQueries(['state-list'])
    },
    onError:(err) => {
      message.error(err?.message)
    }
  });
}


// list state
export function useListState(){
  return useQuery(['state-list'], async() => {
    const { data } = await axios.get(route.LIST_STATE);
    return data;
  });
}

export function useDeleteState(){
  const queryClient = useQueryClient();
  return useMutation(async(id) => {
    const { data } = await axios.delete(`${route.DELETE_STATE}/${id}`);
    return data;
  }, {
    onSuccess:() => {
      message.success('State Deleted successfully');
      queryClient.invalidateQueries(['state-list'])
    },
    onError:(err) => {
      message.error(err?.message)
    }
  });
}


//  ================================================================

// add District
export function useAddDistrict(){
  const queryClient = useQueryClient();
  return useMutation(async(payload) => {
    const { data } = await axios.post(route.ADD_DISTRICT ,payload);
    return data;
  }, {
    onSuccess:() => {
      message.success('District added successfully');
      queryClient.invalidateQueries(['district-list'])
    },
    onError:(err) => {
      message.error(err?.message)
    }
  });
}


// list state
export function useListDistrict(){
  return useQuery(['district-list'], async() => {
    const { data } = await axios.get(route.LIST_DISTRICT);
    return data;
  });
}

export function useDeleteDistrict(){
  const queryClient = useQueryClient();
  return useMutation(async(id) => {
    const { data } = await axios.delete(`${route.DELETE_DISTRICT}/${id}`);
    return data;
  }, {
    onSuccess:() => {
      message.success('District Deleted successfully');
      queryClient.invalidateQueries(['district-list'])
    },
    onError:(err) => {
      message.error(err?.message)
    }
  });
}



// add District
export function useAddArea(){
  const queryClient = useQueryClient();
  return useMutation(async(payload) => {
    const { data } = await axios.post(route.ADD_AREA ,payload);
    return data;
  }, {
    onSuccess:() => {
      message.success('Area added successfully');
      queryClient.invalidateQueries(['area-list'])
    },
    onError:(err) => {
      message.error(err?.message)
    }
  });
}


// list state
export function useListArea(){
  return useQuery(['area-list'], async() => {
    const { data } = await axios.get(route.LIST_AREA);
    return data;
  });
}




export function useDeleteArea(){
  const queryClient = useQueryClient();
  return useMutation(async(id) => {
    const { data } = await axios.delete(`${route.DELETE_AREA}/${id}`);
    return data;
  }, {
    onSuccess:() => {
      message.success('Area Deleted successfully');
      queryClient.invalidateQueries(['area-list'])
    },
    onError:(err) => {
      message.error(err?.message)
    }
  });
}
